// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"number-roller_wrapper_18C86","current":"number-roller_current_3o_VZ"};